export enum KeyVaultKeys {
  // STI
  AlineaSti = 0,
  KurzweilSti = 1,

  // Core licenses
  DediconAuthorizationToken = 3,

  // DODP
  StentorDodp = 4,
}
